import * as React from 'react';

/**
 * Sets `document.title` to `"<title> · <suffix>"`, or just the suffix while
 * the title is unknown, so each route has its own tab and history name
 * (WCAG 2.4.2). Shells call it with the translated route title they already
 * show in the top bar.
 */
export function useDocumentTitle(title: string | undefined, suffix: string): void {
  React.useEffect(() => {
    document.title = title ? `${title} · ${suffix}` : suffix;
  }, [title, suffix]);
}
